import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentWaybillTrackingFacade } from './shipment-waybill-tracking.facade';
import { WaybillIdView } from '../../../../models';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillTrackingGuard {
  constructor(
    private shipmentWaybillTrackingFacade: ShipmentWaybillTrackingFacade,
    private shipmentWaybillItemFacade: ShipmentWaybillItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$.pipe(
      switchMap((identifier: WaybillIdView) => {
        return loadStoreState(this.shipmentWaybillTrackingFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillTrackingFacade);
  }
}
